import React, { createContext, useState, useEffect, useContext } from "react";

export const AppStateContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [bannerList, setBannnerList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [language, setLanguage] = useState("en");
  const [notification, setNotification] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [refreshNotification, setRefreshNotification] = useState(false);



  useEffect(() => {
    setLoading(true)
    let lang = localStorage.getItem("languageSet")
    lang = lang ? lang : 'en';

    if (lang == "ar") {
      import('../assets/styles/main.css')
    } else {
      import('../assets/styles/main.css')
    }
    setTimeout(() => setLoading(false), 200)
    setLanguage(lang)
  }, [])

  useEffect(() => {
    const cached = localStorage.getItem("live_notifications");
    const currentUserRaw = localStorage.getItem("user");
    let currentUserId = null;

    try {
      const currentUser = currentUserRaw ? JSON.parse(currentUserRaw) : null;
      currentUserId = currentUser?.id || currentUser?._id || currentUser?.user_id || null;
    } catch {
      currentUserId = null;
    }

    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        if (Array.isArray(parsed)) {
          const filteredCached = parsed.filter((item) => {
            const senderType = String(item?.senderType || "").toUpperCase();
            return senderType === "USER";
          });
          setNotification(filteredCached);
          setNotificationCount(filteredCached.length);
          localStorage.setItem("live_notifications", JSON.stringify(filteredCached));
        }
      } catch (e) {
        console.error("Failed to parse cached notifications", e);
      }
    }

    const handleNotification = (event) => {
      const incoming = event?.detail || {};
      const senderType = String(incoming?.sender_type || "").toUpperCase();

      // Keep only received user notifications.
      if (senderType !== "USER") return;
      if (
        currentUserId &&
        incoming?.sender &&
        Number(incoming.sender) === Number(currentUserId)
      ) {
        return;
      }

      const normalized = {
        id: incoming.id || incoming._id || Date.now(),
        title: "Notification",
        description: "You have received a notification",
        time: incoming.created_at || new Date().toISOString(),
        ticket: incoming.ticket || null,
        senderType,
      };

      setNotification((prev) => {
        const next = [normalized, ...prev].slice(0, 50);
        localStorage.setItem("live_notifications", JSON.stringify(next));
        setNotificationCount(next.length);
        return next;
      });
    };

    window.addEventListener("app-notification", handleNotification);
    return () => {
      window.removeEventListener("app-notification", handleNotification);
    };
  }, []);



  return (
    <AppStateContext.Provider
      value={{
        bannerList,
        loading,
        setLoading,
        language,
        setLanguage,
        notification,
        setNotification,
        notificationCount,
        setNotificationCount,
        refreshNotification,
        setRefreshNotification,
      }}
    >
      {children}
    </AppStateContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppStateContext);
};
